import { Snackbar } from '@mui/material';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Icon, IconButton } from '@hevoio/hevo-ui-toolkit';
import useAnalyticsTracker from '../../../../../analytics/hooks/useAnalyticsTracker';

const LEGAL_NOTIFICATION_DISMISSED_KEY = 'legal_notification_dismissed_v2';
const TRACK_LEGAL_BANNER_CLOSE_KEY = '[Legal Notification Banner] close banner click';
const TRACK_LEGAL_BANNER_OPEN_KEY = '[Legal Notification Banner] open banner';
export function LegalNotificationSnackbar() {
  const [open, setOpen] = useState(false);
  const { eventTrack } = useAnalyticsTracker();
  
  useEffect(() => {
    const isDismissed = localStorage.getItem(LEGAL_NOTIFICATION_DISMISSED_KEY);
    if (!isDismissed) {
      eventTrack({
        action: TRACK_LEGAL_BANNER_OPEN_KEY
      });
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    eventTrack({
      action: TRACK_LEGAL_BANNER_CLOSE_KEY
    });
    localStorage.setItem(LEGAL_NOTIFICATION_DISMISSED_KEY, 'true');
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      classes={{
        root: 'flex-no-wrap'
      }}
      message={
        <div className='d-flex text-body-1 flex-no-wrap' style={{ maxWidth: '800px' }}>
          <div className=''>
            <span>
              <span data-text='true'>
                Hevo has updated its{' '}
                <a href='https://hevodata.com/terms/' target='_blank' rel='noopener'>
                  <span>
                    <span data-text='true' className='text-link text-primary'>
                      Terms of Service
                    </span>
                  </span>
                </a>
                . We encourage you to review these updates as described on our{' '}
              </span>
            </span>
            <a href='https://hevodata.com/legal-resources/#terms' target='_blank' rel='noopener'>
              <span>
                <span data-text='true' className='text-link text-primary'>
                  Legal Resources
                </span>
              </span>
            </a> page.
            <span data-offset-key='ain11-2-0'>
              <span data-text='true'>
                {' '}By continuing to use our services on or after April 15, 2026, you agree to the
                updated terms.
              </span>
            </span>
          </div>
          <IconButton
            disableRipple
            color='inherit'
            className={clsx('ml-2 p-1')}
            label={''}
            dataId={''}
            onClick={handleClose}
          >
            <Icon name='close' />
          </IconButton>
        </div>
      }
      key={'bottom' + 'center'}
    />
  );
}
